import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React, { useEffect, useState } from 'react'
import { Smartphone } from 'lucide-react'
export default function InstallApp({ className }) {
  useInterfaceLanguage();
  const [prompt, setPrompt] = useState(null)
  const [message, setMessage] = useState('')
  const [installed, setInstalled] = useState(() => window.matchMedia('(display-mode: standalone)').matches || !!navigator.standalone)
  useEffect(() => {
    const beforeInstall = event => { event.preventDefault(); setPrompt(event) }
    const onInstalled = () => { setInstalled(true); setPrompt(null) }
    window.addEventListener('beforeinstallprompt', beforeInstall)
    window.addEventListener('appinstalled', onInstalled)
    return () => { window.removeEventListener('beforeinstallprompt', beforeInstall); window.removeEventListener('appinstalled', onInstalled) }
  }, [])
  const install = async () => {
    if (prompt) {
      await prompt.prompt()
      await prompt.userChoice
      setPrompt(null)
    } else if (/iPad|iPhone|iPod/.test(navigator.userAgent)) setMessage(tr("Откройте «Поделиться» в Safari и выберите «На экран Домой»."))
    else setMessage(tr("В меню браузера выберите «Установить приложение». Если пункт недоступен, добавьте страницу в закладки: Ctrl+D или Cmd+D."))
  }
  if (installed) return null
  return <div><button type="button" onClick={install} className={className}><Smartphone size={15} />{tr("Установить приложение")}</button>{tr(message && <p role="status" style={{ fontSize: 11, lineHeight: 1.5, color: "var(--theme-text-muted, #7c8291)", marginTop: 7 }}>{tr(message)}</p>)}</div>
}
